import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function confirmationApi(confirmationId, callback) {
	console.log('confirmationDetails');
	firebaseRef
		.ref('/kavtek_confirmation_messages/' + PROJECT_CODE.projectCode)
		.orderByChild('id')
		.equalTo(confirmationId)
		.once('value', (snapshot) => {
			console.log('snapshot', snapshot.child());

			var confirmationKey = Object.keys(snapshot.val())[0];

			console.log('confirmationKey', confirmationKey);

			var message = snapshot.val()[confirmationKey].message;
			var title = snapshot.val()[confirmationKey].title;
			var confirmationDetails = {
				message: message,
				title: title,
			};
			console.log('confirmationDetails', confirmationDetails);
			callback(confirmationDetails);
		});
}
